import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import FormatterExampleCard from "@/components/formatter/FormatterExampleCard";
import FormatterApiExample from "@/components/formatter/FormatterApiExample";
import { ALL_FORMAT_SLUG_EXAMPLES } from "@/data/formatterAllExamples";
import { Heading } from "@/components/ui/heading";
import ExamplesPageLayout from "@/components/layout/ExamplesPageLayout";

export default function ExampleDetailPage() {
	const { slug } = useParams();
	const navigate = useNavigate();
	const example = ALL_FORMAT_SLUG_EXAMPLES.find((ex) => ex.slug === slug);
	const headingText = example?.label ?? slug ?? "format";
	const [liveInput, setLiveInput] = useState(example?.text ?? "");

	useEffect(() => {
		if (!example) {
			navigate("/404", { replace: true });
		}
	}, [example, navigate]);

	useEffect(() => {
		if (example) {
			setLiveInput(example.text);
		}
	}, [example]);

	if (!example) return null;

	return (
		<ExamplesPageLayout width="6xl" paddingY="6">
			<Heading>{headingText}</Heading>
			<div className="space-y-6">
				<FormatterExampleCard
					key={example.id}
					title={example.label}
					showTitle={false}
					initialInput={example.text}
					onInputChange={setLiveInput}
					defaultMode={example.contentType}
					defaultOptions={example.options}
					defaultTransforms={example.transforms}
				/>
				<FormatterApiExample example={example} textOverride={liveInput} />
			</div>
		</ExamplesPageLayout>
	);
}
